import { EventValueEnum, UserRoleEnum } from "../types/communication/communicationDataType";
import { faFileSignature } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PlainInfoCard } from "../components/styled/Card.style";
import { Section } from "../components/styled/Containers.style";
import { IconContainer } from "../components/styled/Icon.style";
import { Vspace } from "../components/styled/Separators.style";
import { BigText, TextDefault } from "../components/styled/Text.style";
import { PATHS } from "../routes/CaiExperienceRouter";
import PageContainerCmp from "./PageContainerCmp";
import { useAppSelector } from "../store/hooks";
import { selectCommunicationData } from "../store";
import { AUTH_CONFIRM_PATHS } from "../routes/AuthConfirmRouter";
//import { isCounterProposal } from "../utils/utils";

/* istanbul ignore next */
const EndSignatureForwardSuccessPage = () => {
    const communicationData = useAppSelector(selectCommunicationData);
    const { communication } = communicationData
    //const _isCounterProposal = isCounterProposal(communication)
    const isCtp = communication?.userRole === UserRoleEnum.CTP || false;

    return (
        <>
            <PageContainerCmp
                routePath={isCtp === true ? AUTH_CONFIRM_PATHS.AUTHORIZE_END_SIGNATURE_FORWARD_SUCCESS : PATHS.END_SIGNATURE_FORWARD_SUCCESS}
                removeNextBtn={true}
                isForceLastPathname={true}
                eventsOnLoad={[EventValueEnum.CONFIRMED]}>
                <Section>
                    <PlainInfoCard>
                        <IconContainer>
                            <FontAwesomeIcon icon={faFileSignature} />
                        </IconContainer>
                        <Vspace></Vspace>
                        <Vspace></Vspace>
                        <BigText>Ben fatto, grazie!</BigText>
                    </PlainInfoCard>
                    <Vspace qty={3}></Vspace>
                    {isCtp ? <TextDefault intL={true} centered={true}>Riceverai via email/SMS informazioni sull'inoltro della pratica.</TextDefault> : <>
                        <TextDefault intL={true} centered={true}>Procediamo contattando la controparte per sottoporle la Constatazione Amichevole che, eventualmente, potrebbe firmare a sua volta.</TextDefault>
                        <Vspace qty={2}></Vspace>
                        <TextDefault intL={true} centered={true}>Entro massimo 24 ore, riceverai via email informazioni sull'inoltro della pratica.</TextDefault>
                    </>}
                </Section>
            </PageContainerCmp >
        </>
    )
}

export default EndSignatureForwardSuccessPage